import { Component, Input } from '@angular/core';

import { CommonService, PhxConstants } from '../../../../common';
import { CodeValueService } from '../../../../common/services/code-value.service';
import { GlobalSearchService } from '../../../services/global-search-service';

@Component({
  selector: 'app-global-search-suggestion-assignment',
  templateUrl: './global-search-suggestion-assignment.component.html',
  styleUrls: ['./global-search-suggestion-assignment.component.less'],
  standalone: false
})
export class GlobalSearchSuggestionAssignmentComponent {
  @Input() assignmentData;
  readonly dateFormat = PhxConstants.DateFormat.mediumDate;

  constructor(
    private commonService: CommonService, 
    private globalSearchService: GlobalSearchService,
    private codeValueService: CodeValueService
  ) {}

  getProfileTypeForDisplay(profileTypeCode, t4TypeId) {
    let profileType = this.commonService.getUserProfileTypeFromProfileTypeCode(profileTypeCode);
    
    if (t4TypeId) {
      const t4TypeText = this.codeValueService.getCodeValueText(t4TypeId, 'usr.CodeProfileWorkerT4Type');
      if (t4TypeText) {
        profileType += ` - ${t4TypeText}`;
      }
    }
    
    return profileType;
  }

  onWorkOrderSuggestionClick(item) {
    this.globalSearchService.onWorkOrderSuggestionClick(item);
  }
}
